import React, { Component } from 'react';
import '../index.css';

function Title(props) {
  return (
    <div
      style={{
        paddingTop: '30px',
        width: '100%',
        position: 'relative',
        ...props.style,
      }}
    >
      <p style={{ fontSize: 30 }}>{props.title}</p>
      {props.title === '콘텐츠 설정' || props.title === '콘텐츠 변경' || props.title === '게시 콘텐츠 관리' ? null : (
        <div
          style={{
            marginBottom: 15,
            marginTop: 15,
            border: '0.5px solid #848484',
          }}
        ></div>
      )}
    </div>
  );
}

export default Title;
